import React from 'react'


const PDF = (props) =>
    <svg
        {...props}
        viewBox="0 0 28 31.94"
        xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"
      >
        <path d="M27 19.978h-3v1.995h2a.999.999 0 1 1 0 1.996h-2v2.993a.999.999 0 0 1-1 .998c-.553 0-1-.447-1-.998V18.98c0-.55.447-.997 1-.997h4a.998.998 0 1 1 0 1.995zM8 27.96c-.553 0-1-.447-1-.998V18.98c0-.55.447-.997 1-.997h2c1.683 0 3 1.524 3 3.471 0 1.922-1.305 3.464-2.971 3.512H9v1.996a.999.999 0 0 1-1 .998zm2-4.989c.477-.014 1-.586 1-1.517 0-.924-.509-1.476-1-1.476H9v2.993h1zm5 4.989c-.553 0-1-.447-1-.998V18.98c0-.55.447-.997 1-.997h2.098A3.902 3.902 0 0 1 21 21.876v2.19a3.903 3.903 0 0 1-3.902 3.894H15zm4-3.894v-2.19a1.902 1.902 0 0 0-1.902-1.898H16v5.987h1.098A1.903 1.903 0 0 0 19 24.066zm5-9.077a.998.998 0 0 1-1 .998c-.553 0-1-.446-1-.998v-3.99h-8c-.553 0-1-.447-1-.999V1.97H2v27.96l21 .025a.999.999 0 1 1 0 1.996H2.025A2.025 2.025 0 0 1 0 29.93V2.044C0 .93.908.023 2.025.023H14c.024 0 .044.012.067.014.088.006.172.023.255.051.034.012.068.02.1.036a.998.998 0 0 1 .28.188l.006.005 8.891 8.869c.031.023.047.061.076.087.029.027.051.058.077.089.154.175.267.387.267.638 0 .034-.016.063-.019.097v4.892zm-9-11.56v5.574h5.586L15 3.429z"
              fillRule="evenodd"/>
    </svg>

export default PDF


// WEBPACK FOOTER //
// ./src/components/_common/_icons/PDF.js